import React from 'react';
import { Footer } from 'pods/footer';
import { TopBar } from 'pods/topbar';
import { DocReqMain } from 'pods/main';
export const DocumentalScene = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement(TopBar, null),
            React.createElement("main", null,
                React.createElement(DocReqMain, null))),
        React.createElement(Footer, null)));
};
